import React from 'react';
import { Stack, Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { Modal, Spinner } from 'shared';

export interface SendModalPayload {
  data?: null;
  type: ModalType.Send;
  isOpen?: boolean;
}

export const SendModal = React.forwardRef<
  HTMLElement,
  Pick<SendModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose }, ref) => {
  return (
    <Modal ref={ref}>
      <Stack alignItems="center">
        <Typography variant="h5" component="span" color="inherit" className="no-resize">
          STEP 2/2{' '}
          <Typography variant="inherit" component="span" className="accent">
            SEND
          </Typography>
        </Typography>
        <Spinner
          sx={{
            mt: 4,
            mb: 3,
          }}
        />
        <Typography
          variant="h5"
          className="center"
          component="span"
          color="inherit"
          fontSize={18}
          sx={{
            maxWidth: 332,
            mb: 2,
          }}
        >
          Please press &#34;Send&#34; button in Metamask extension
        </Typography>
      </Stack>
    </Modal>
  );
});
